import type { TOC } from '@ember/component/template-only';
import MobileHeader from '../components/mobile-header.gts';

interface Signature {
  Args: {};
}

const MySourcesLoading: TOC<Signature> = <template>
  <MobileHeader @title="My Sources" />
  <div class="flex justify-center py-12">
    <span class="loading loading-spinner loading-lg"></span>
  </div>
</template>;

export default MySourcesLoading;
